import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import PropTypes from 'prop-types'
import { Outlet } from 'react-router-dom'

const GET_ME = gql`
  query getMe {
    me {
      _id
      hasAcceptedLastTermsOfService
    }
  }
`

const TermsVerifier = () => {
  const navigate = useNavigate()
  const { data } = useQuery(GET_ME, {
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    const checkRoute = () => {
      if (!data?.me) return
      const { pathname } = window.location
      const allowedRoutes = [
        '/terms-of-service-updated',
        '/privacy-policy',
        '/terms-and-conditions',
        '/',
      ]
      if (!allowedRoutes.includes(pathname) && data.me.hasAcceptedLastTermsOfService === false) {
        // navigate('/terms-of-service-updated')
      }
    }
    checkRoute()
  }, [data, navigate])

  return <Outlet />
}

TermsVerifier.propTypes = {
  children: PropTypes.node,
}

export default TermsVerifier
